(function () {
    var M = window.MDMeals;
    if (!M || !M.api) {
        return;
    }

    function prep() {
        return typeof mdMealPrep !== 'undefined' ? mdMealPrep : {};
    }

    function rootEl(from) {
        return from && from.closest ? from.closest('[data-md-meal-detail]') : null;
    }

    function goSignIn(r) {
        var url = r && r.getAttribute('data-signin-url');
        if (url) {
            window.location.href = url;
        }
    }

    function setFav(btn, on) {
        btn.classList.toggle('is-active', !!on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    function setReq(btn) {
        btn.classList.add('is-active');
        btn.setAttribute('data-md-requested', '1');
        btn.textContent = 'Requested';
    }

    function onFav(btn) {
        var r = rootEl(btn);
        if (!r) {
            return;
        }
        if (!prep().isLoggedIn) {
            goSignIn(r);
            return;
        }
        var mealId = parseInt(btn.getAttribute('data-meal-id'), 10) || 0;
        M.api('favorites/toggle', { method: 'POST', body: { meal_id: mealId } }).then(function (res) {
            if (!res || !res.ok) {
                return;
            }
            var on = !!res.on;
            setFav(btn, on);
        }).catch(function () {});
    }

    function onReq(btn) {
        var r = rootEl(btn);
        if (!r) {
            return;
        }
        if (!prep().isLoggedIn) {
            goSignIn(r);
            return;
        }
        if (btn.getAttribute('data-md-requested') === '1') {
            return;
        }
        var mealId = parseInt(btn.getAttribute('data-meal-id'), 10) || 0;
        var menuId = parseInt(r.getAttribute('data-menu-id'), 10) || 0;
        var body = {
            meal_id: mealId,
            source: menuId > 0 ? 'closed_menu' : 'library'
        };
        M.api('meal/request', { method: 'POST', body: body }).then(function (res) {
            if (res && res.ok) {
                setReq(btn);
            }
        }).catch(function () {});
    }

    document.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) {
            return;
        }
        var btn = t.closest('[data-md-action]');
        if (!btn) {
            return;
        }
        var act = btn.getAttribute('data-md-action');
        if (act === 'favorite') {
            e.preventDefault();
            onFav(btn);
        } else if (act === 'request') {
            e.preventDefault();
            onReq(btn);
        }
    });
})();
